export default __webpack_public_path__ + "static/media/jsquestion.85aaebed.jpeg";